import forEach from "ramda/es/forEach";
import identity from "ramda/es/identity";
import isNil from "ramda/es/isNil";
import keys from "ramda/es/keys";
import { CALL_API } from '../../../constants';
import { clearCachedRequest, setCachedRequest } from '../../../redux/cache/actions';
import { getIsRequestCached, getIsRequestStaled, getRequestData } from '../../../redux/cache/selectors';
import { setRequestStatus } from '../../../redux/status/actions';
import { requestStates } from '../../../redux/status/constants';
import { appendApiRequestActions, checkAndAppendApiRequestActions } from '../../../utils';
import { createActionMeta } from '../../utils';
import { createActionCache } from '../utils/createActionCache';
/**
 * cache middleware
 *
 * @documented
 * @category api-middleware
 *
 */ const cacheMiddleware = ()=>({ dispatch, getState })=>(next)=>async (action)=>{
                const callAPI = action[CALL_API];
                if (!callAPI || isNil(callAPI.cache)) {
                    return next(action);
                }
                const state = getState();
                const actionMeta = createActionMeta(callAPI.meta);
                const { cacheKey, dataManipulation = identity, staleTime, clearCacheAfterError } = await createActionCache(callAPI)(state);
                const requestCached = getIsRequestCached(cacheKey)(state);
                const requestStaled = getIsRequestStaled(cacheKey)(state);
                if (requestCached && !requestStaled) {
                    dispatch(setRequestStatus({
                        requestUuid: actionMeta.requestUuid,
                        status: requestStates.COMPLETED
                    }));
                    return Promise.resolve({
                        ...getRequestData(cacheKey)(state),
                        cache: {
                            fromCache: true,
                            cacheKey,
                            staleTime
                        }
                    });
                }
                const requestActions = {
                    onSuccess: [
                        (data)=>setCachedRequest({
                                requestUuid: actionMeta.requestUuid,
                                timestamp: actionMeta.timestamp,
                                data: dataManipulation(data),
                                cacheKey,
                                staleTime
                            })
                    ],
                    onError: clearCacheAfterError ? [
                        clearCachedRequest({
                            cacheKey
                        })
                    ] : [],
                    onRequest: [],
                    onCancel: []
                };
                const appendApiActions = appendApiRequestActions(callAPI.actions, requestActions);
                const checkAndAppendApiActions = checkAndAppendApiRequestActions(callAPI.actions, appendApiActions);
                forEach(checkAndAppendApiActions, keys(requestActions));
                return next({
                    [CALL_API]: {
                        ...callAPI,
                        meta: actionMeta,
                        actions: requestActions
                    }
                });
            };
export default cacheMiddleware;
